import PropTypes from 'prop-types'
import React from 'react'
import cc from 'classcat'

import styles from './Icon.css'

import icons from './icons'

function IconBase({ name, size = '24', color, onClick, spin }) {
  const classNames = cc([
    styles.icon,
    {
      [styles.spin]: spin,
    },
  ])

  const viewBoxSize = Number(size) < 24 ? '24' : size
  return (
    <svg
      className={classNames}
      onClick={onClick}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
    >
      <path fill={color} d={icons[name]} />
    </svg>
  )
}

IconBase.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  spin: PropTypes.bool,
  color: PropTypes.string,
}

IconBase.defaultProps = {
  onClick: undefined,
  size: '24',
  spin: false,
  color: undefined,
}

export default IconBase
